<script setup>
import { ref } from "vue";
import useActionButtonsCommon from "@/composables/ActionButtonsCommon";

const { store, loading, _error } = useActionButtonsCommon();

const props = defineProps({
  modelValue: {
    type: Boolean,
    required: true,
  },
});

const emit = defineEmits(["update:modelValue"]);

const multisearch = ref({
  draw: 1,
  length: 10,
  start: 1,
  devices: "",
  columns: [],
  order: [],
});

const closeModal = () => {
  _error.value = null;
  emit("update:modelValue", false);
  multisearch.value.devices = "";
};

const sendmultisearch = async () => {
  if (multisearch.value.devices.trim()) {
    try {
      loading.value = true;
      await store.dispatch("devices/multiDeviceSearch", multisearch.value);
      store.dispatch("toastNotification/displayToast", {
        message: "Devices found",
        type: "success",
      });
      loading.value = false;
      closeModal();
    } catch (error) {
      loading.value = false;
      _error.value = error?.message || "Error sending multisearch query";
      store.dispatch("toastNotification/displayToast", {
        message: error?.message || "Error sending multisearch query",
        type: "warning",
      });
      console.error("Error sending multisearch query:", error);
    }
  }
};
</script>

<template>
  <div v-if="modelValue">
    <div class="modal fade show d-block" tabindex="-1" role="dialog">
      <div class="modal-backdrop fade show" @click="closeModal"></div>
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">Multiple Devices Search</h4>
            <button type="button" class="close" @click="closeModal">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <div class="modal-body">
            <div class="form-group">
              <textarea
                class="form-control bg-white"
                rows="10"
                v-model="multisearch.devices"
                placeholder="Enter device imei in each line"
              ></textarea>
            </div>
            <p v-if="_error" class="text-danger">
              {{ _error }}
            </p>
          </div>

          <div class="modal-footer justify-content-end">
            <button type="button" class="btn btn-danger" @click="closeModal">
              CLOSE
            </button>
            <button
              v-if="!loading"
              type="button"
              class="btn btn-success"
              @click="sendmultisearch"
              :disabled="multisearch.devices.trim() === ''"
            >
              SEARCH
            </button>
            <div
              v-if="loading"
              class="justify-content-center align-items-center"
              style="text-align: center"
            >
              <font-awesome-icon :icon="['fas', 'spinner']" spin size="2x" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
@import "@/styles/modal.css";

.form-control {
  resize: none;
}
</style>
